import React from 'react';

import type { Variant as CloseIconVariant } from '@swf/components/StarsModal/components/CloseButton';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';

import { parseURL } from '../../utils';

import styles from './Header.scss';

export enum HeaderVariant {
  Default = 'default',
  Large = 'large'
}

interface Props {
  showCloseIcon: boolean;
  headerImageURL?: string;
  closeIconVariant?: CloseIconVariant;
  defaultHeaderImageURL?: string;
  styleType?: string;
  variant?: HeaderVariant;
  onClickClose?(): void;
}

const Header: React.FC<Props> = ({
  showCloseIcon,
  closeIconVariant,
  headerImageURL,
  defaultHeaderImageURL,
  variant,
  onClickClose
}) => {
  const primaryHeaderURL = parseURL(headerImageURL || '');
  const variantStyle = styles[variant || HeaderVariant.Default];
  return (
    <header
      className={`${styles.notificationHeader} ${variantStyle}`}
      style={{
        backgroundImage: `url(${primaryHeaderURL}), url(${defaultHeaderImageURL})`
      }}
    >
      {showCloseIcon && <CloseButton onClick={onClickClose} variant={closeIconVariant} />}
    </header>
  );
};

export default Header;
